import apiClient from './api';

export const getWhitelistStatus = () => apiClient.get(`/setting/whitelist-status`);

export const upsertWhitelistStatus = (status) => apiClient.post(`/setting/whitelist-status`, { status });

export const getUsersWhitelistAnnouncement = () => apiClient.get(`/setting/users-whitelist-announcement`);

export const insertUserWhitelistAnnouncement = (username) => apiClient.post(`/setting/insert/user-whitelist-announcement`, { username });

export const deleteUserWhitelistAnnouncement = (setting_id) => apiClient.post(`/setting/delete/user-whitelist-announcement`, { setting_id });

export const getHubStatus = () => apiClient.get(`/setting/hub-status`);

export const getThemeSite = () => apiClient.get(`/setting/theme-site`);

export const updateThemeSite = (theme) => apiClient.put(`/setting/theme-site`, { theme });

export const getCustomButton = () => apiClient.get(`/setting/custom-button`);

export const updateCustomButton = (enabled, url, icon, tooltip) => apiClient.put(`/setting/custom-button`, { enabled, url, icon, tooltip });